import { render, staticRenderFns } from "./AdvisorDashboardOptimized.vue?vue&type=template&id=413bb48f&scoped=true"
import script from "./AdvisorDashboardOptimized.vue?vue&type=script&lang=js"
export * from "./AdvisorDashboardOptimized.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDashboardOptimized.vue?vue&type=style&index=0&id=413bb48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413bb48f",
  null
  
)

export default component.exports